module.exports = __webpack_public_path__ + "static/media/4.5b933ebc.png";